'use client';

import clsx from 'clsx';
import Image from 'next/image';
import HorizontalRangeChart from '../../HorizontalRangeChart/HorizontalRangeChart';

import { LocationStoryblok, UnitTypeStoryblok } from '@/types/storyblok/storyblok-types';

import styles from './SimulationSection.module.scss';

type SectionProps = {
    location: LocationStoryblok;
    className?: string;
    investmentAmount: number;
    exchangeRate: number;
    currency: string;
};

export const SimulationSection = ({ location, className, investmentAmount, exchangeRate, currency }: SectionProps) => (
    <div className={clsx(styles.root, className)}>
        <div
            style={{
                height: '100%',
                zIndex: 2,
                position: 'relative',
            }}
        >
            <h3
                style={{
                    marginBottom: '24px',
                }}
            >
                {location.name}
            </h3>

            <div className={styles.content}>
                <ul className={styles.infoWrap}>
                    {location.types.map((t: UnitTypeStoryblok) => (
                        <li
                            className={styles.row}
                            key={`${t._uid}${t?.isOffPlan ? '-offplan' : ''}`}
                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Image
                                                className={styles.image}
                                                src={t.image.filename}
                                                alt={t.image.alt}
                                                width={30}
                                                height={30}
                                            />
                                        </td>
                                        <td>
                                            <p
                                                className={styles.locInfo}
                                            >{`${t.name}${t?.isOffPlan ? ' - Off plan' : ''}`}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </li>
                    ))}
                </ul>

                <div className={styles.chart}>
                    <HorizontalRangeChart
                        location={location}
                        investmentAmount={investmentAmount}
                        exchangeRate={exchangeRate}
                        currency={currency}
                    />
                </div>
            </div>
        </div>
    </div>
);
